import { TopicFilters, TopicSorting } from "./types";

export const PRECISION = 2;
const NUMBER_TO_HIDE = 5;
const MIN_ALLOW_DURATION = 3;
const MAX_ALLOW_DURATION = 12;

export const LOADER_HEIGHT = 20;
export const LOADER_WIDTH = 100;
export const KEYWORDS_LOADER_HEIGHT = LOADER_HEIGHT / 1.5;
export const KEYWORDS_LOADER_WIDTH = LOADER_WIDTH / 1.5;

const COLLAPSE_HEIGHT = "440px";
const EXPAND_HEIGHT = "100%";
export const MAXIMUM_TOPICS = 20;
export const SINGLE = 1;
export const EXCEL_DOWNLOAD_LINK = "api/KeywordAnalysis/keywordsListReport/Excel";

export const TOPICS_WRAPPER_ID = "topicsWrapperId";

export const FILTER_ITEMS = [
    { id: TopicFilters.All, text: "activation.widget.topics.filter.all.text" },
    { id: TopicFilters.Inc, text: "activation.widget.topics.filter.increasing.text" },
    { id: TopicFilters.Dec, text: "activation.widget.topics.filter.decreasing.text" },
    { id: TopicFilters.Lead, text: "activation.widget.topics.filter.leader.text" },
];

export const SORT_ITEMS = [
    { id: TopicSorting.ShareOfVoice, text: "activation.widget.topics.sort.shareOfVoice.text", field: "shareOfVoice" },
    { id: TopicSorting.Vol, text: "activation.widget.topics.sort.volume.text", field: "volume" },
    {
        id: TopicSorting.ShareChange,
        text: "activation.widget.topics.sort.shareChange.text",
        field: "shareOfVoiceChange",
    },
    { id: TopicSorting.MostRecent, text: "activation.widget.topics.sort.mostRecent.text", field: "created" },
    { id: TopicSorting.Name, text: "activation.widget.topics.sort.name.text", field: "name" },
];
